import { DataTable  } from 'primereact/datatable';  

const DataTablez = ({...rest}) => {
    return (
        <DataTable{...rest} />
    )
};

export default DataTablez;